export const FETCH_YARD_MAP = "FETCH_YARD_MAP";
export const FETCH_YARD_MAP_SUCCESS = "FETCH_YARD_MAP_SUCCESS";
export const FETCH_YARD_MAP_FAILURE = "FETCH_YARD_MAP_FAILURE";

export const CREATE_YARD_MAP = "CREATE_YARD_MAP";
export const CREATE_YARD_MAP_SUCCESS = "CREATE_YARD_MAP_SUCCESS";
export const CREATE_YARD_MAP_FAILURE = "CREATE_YARD_MAP_FAILURE";

export const DELETE_YARD_MAP = "DELETE_YARD_MAP";
export const DELETE_YARD_MAP_SUCCESS = "DELETE_YARD_MAP_SUCCESS";
export const DELETE_YARD_MAP_FAILURE = "DELETE_YARD_MAP_FAILURE";

export const RESET_YARD_MAP_STATE = "RESET_YARD_MAP_STATE";

export const CLEAR_ERROR_DELETING_YARD_MAP = "CLEAR_ERROR_DELETING_YARD_MAP";
